export enum CrudActivatedModes {
  Selection,
  New,
  Edit,
  View,
  Validate,
}
